<div [class]="'status ' + request.type">
  <img class="status-image" [src]="statusImageSrc" alt="status" />
  <div class="status-description">{{ this.statusDescription }}</div>
  @if (showPayAgainButton) {
    <div class="status-comment">Keer terug naar het betaalverzoek als je het opnieuw wilt proberen.</div>
    <a class="submit-button" [href]="request.publicId">Terug naar betaalverzoek</a>
  }
</div>
